import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import UISection from 'UIComponents/section/UISection';
import PlaylistThumbnailBlank from '../components/TrackCard/Thumbnail/PlaylistThumbnailBlank';
import PlaylistThumbnailOverlayed from '../components/TrackCard/Thumbnail/PlaylistThumbnailOverlayed';
import { PlaylistAssignmentsMonitoringRoutes } from '../features/playlistAssignments';
import { PlaylistDetails, PlaylistPageHeader } from '../features/savedItems';
import { PlaylistItems, usePlaylistSearchManagerOpenState } from '../features/playlistItems';
import styled, { academyPageFullWidth, css, mediaQuery, theme } from 'academy-common-lib/utils/Styling';
import { safeSmoothScrollTo } from '../utils/utils';
import { SavePlaylistTooltip } from '../features/myPlaylists';
import { ScrollIntoView } from '../features/routing';
import useWootricSurvey from '../hooks/useWootricSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyWidthSection = styled.div.withConfig({
  displayName: "Playlist__AcademyWidthSection",
  componentId: "sc-1rgga6m-0"
})(["", " padding:0 16px;", ""], academyPageFullWidth, mediaQuery('notMobile', css(["padding:0 64px;"])));
const TwoColumnSection = styled(AcademyWidthSection).withConfig({
  displayName: "Playlist__TwoColumnSection",
  componentId: "sc-1rgga6m-1"
})(["margin-top:52px;gap:24px;display:flex;flex-direction:column;", ""], mediaQuery('notTablet', css(["display:grid;grid-template-columns:1fr 1fr;"])));
const BackgroundColoredSection = styled(UISection).withConfig({
  displayName: "Playlist__BackgroundColoredSection",
  componentId: "sc-1rgga6m-2"
})(["background-color:", ";width:100%;display:flex;justify-content:center;margin-bottom:0 !important;overflow:hidden;"], theme.colors.GYPSUM);
const BackgroundColoredSectionContent = styled.div.withConfig({
  displayName: "Playlist__BackgroundColoredSectionContent",
  componentId: "sc-1rgga6m-3"
})(["", " padding:60px 64px;", " .playlist-assignments-list{margin-left:-16px;margin-right:-24px;}"], academyPageFullWidth, mediaQuery('mobile', css(["padding:40px 16px 80px;"])));
const Playlist = () => {
  useWootricSurvey('CSAT');
  const {
    playlistId
  } = useParams();
  const id = parseInt(playlistId, 10);
  const searchInputRef = useRef(null);
  const playlistItemsRef = useRef(null);
  const {
    isPlaylistSearchManagerOpen,
    openPlaylistSearchManager
  } = usePlaylistSearchManagerOpenState();
  const onAddContent = () => {
    if (!searchInputRef || !searchInputRef.current || !playlistItemsRef.current) return;
    safeSmoothScrollTo(playlistItemsRef.current, 0, 0);
    if (!isPlaylistSearchManagerOpen) openPlaylistSearchManager();
    searchInputRef.current.focus();
  };
  return /*#__PURE__*/_jsxs("article", {
    children: [/*#__PURE__*/_jsx(PlaylistPageHeader, {
      playlistId: id
    }), /*#__PURE__*/_jsxs(TwoColumnSection, {
      className: "m-bottom-11",
      children: [/*#__PURE__*/_jsx(PlaylistThumbnailOverlayed, {
        centerContent: /*#__PURE__*/_jsx(PlaylistThumbnailBlank, {
          onAddContent: onAddContent,
          playlistId: id
        }),
        playlistId: id,
        renderMenu: menu => /*#__PURE__*/_jsx(SavePlaylistTooltip, {
          playlistId: id,
          children: menu
        })
      }), /*#__PURE__*/_jsx(PlaylistDetails, {
        playlistId: id
      })]
    }), /*#__PURE__*/_jsx(AcademyWidthSection, {
      ref: playlistItemsRef,
      children: /*#__PURE__*/_jsx(PlaylistItems, {
        playlistId: id,
        searchInputRef: searchInputRef
      })
    }), !isPlaylistSearchManagerOpen && /*#__PURE__*/_jsx(ScrollIntoView, {
      id: "playlist-assignments",
      children: /*#__PURE__*/_jsx(BackgroundColoredSection, {
        className: "m-top-10",
        children: /*#__PURE__*/_jsx(BackgroundColoredSectionContent, {
          children: /*#__PURE__*/_jsx(PlaylistAssignmentsMonitoringRoutes, {})
        })
      })
    })]
  });
};
export default Playlist;